import { useState } from "react";
import styles from "./ScholarshipFAQ.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import AccordionV2 from "@Components/Accordian";
import useIsDesktop from "hooks/useIsDesktop";
import { getScholarshipFaqData, type FAQItem } from "constants/scholarshipConstants";
import useTranslationHook from "hooks/useTranslationHook";

const INITIAL_FAQ_COUNT = 5;

const ScholarshipFAQ = () => {
  const isDesktop = useIsDesktop();
  const [showAll, setShowAll] = useState(false);
  const { t } = useTranslationHook();
  const SCHOLARSHIP_FAQ_DATA = getScholarshipFaqData(t);

  const displayedFAQs = showAll
    ? SCHOLARSHIP_FAQ_DATA
    : SCHOLARSHIP_FAQ_DATA.slice(0, INITIAL_FAQ_COUNT);

  const renderQA = ({ question, answer }: FAQItem) => ({
    title: <h3 className={isDesktop ? styles.question : styles.questionMobile}>{question}</h3>,
    description: <p className={isDesktop ? styles.answer : styles.answerMobile}>{answer}</p>,
  });

  const toggleShowAll = () => {
    setShowAll(!showAll);
  };

  return (
    <div className={styles.scholarshipFAQContainer}>
      <div className={styles.content}>
        <div className={isDesktop ? styles.faqCard : styles.faqCardMobile}>
          <div className={styles.header}>
            <h2 className={isDesktop ? styles.title : styles.titleMobile}>
              {t("scholarship.faq.title")}
            </h2>
          </div>

          <AccordionV2
            data={displayedFAQs.map((faq) => renderQA(faq))}
            isDesktop={isDesktop}
            className={styles.accordionItem}
            addDivider
          />

          {SCHOLARSHIP_FAQ_DATA.length > INITIAL_FAQ_COUNT && (
            <button type="button" className={styles.viewAllButton} onClick={toggleShowAll}>
              <span className={styles.viewAllText}>
                {showAll
                  ? t("scholarship.faq.showless")
                  : `${t("scholarship.faq.viewall")} (${SCHOLARSHIP_FAQ_DATA.length})`}
              </span>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                className={`${styles.viewAllChevron} ${showAll ? styles.expanded : ""}`}
              >
                <path
                  d="M4 6L8 10L12 6"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default wrapperHOC(ScholarshipFAQ, {
  componentName: "ScholarshipFAQ-ScholarshipDesktop",
  showForChina: true,
});
